import React, { useState, useEffect } from 'react'
import './Steps.css'
import { TbListDetails } from "react-icons/tb";
import { MdCo2 } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import { FaArrowRight } from "react-icons/fa";
import { FaPlug } from "react-icons/fa6";
import { FaRecycle } from "react-icons/fa";
import { PiCalendarCheckFill } from "react-icons/pi";
import { FaRobot } from "react-icons/fa6";
import { FaQrcode } from "react-icons/fa";
import { FaChartPie } from "react-icons/fa";

const stepsData = [
  {
    // animation: fill,
    icon: <TbListDetails />,
    text: "Input Event Details"
  },
  {
    // animation: meter,
    icon: <MdCo2 />,
    text: "Get CO₂ Emissions"
  },
  {
    // animation: report,
    icon: <TbReportAnalytics />,
    text: "Generate & Share Report"
  }
];

const featuresData = [
  {
    icon: <FaChartPie />,
    title: "Track Scope 1, 2, & 3 emissions",
    description: "Effortlessly track Scope 1, 2, & 3 emissions. "
  },
  {
    icon: <FaQrcode />,
    title: "Streamline Attendee Tracking",
    description: "Streamline attendee data and travel tracking with custom links, QR codes, forms."
  },
  {
    icon: <FaRobot />,
    title: "AI Powered Reports",
    description: "Generate automated AI-powered reports with ease."
  },
  {
    icon: <FaPlug />,
    title: "API Integration",
    description: "Seamless API integration with registration forms."
  },
  {
    icon: <FaRecycle />,
    title: "Waste Emissions Calculator",
    description: "Calculate waste-related emissions using standardized values."
  },
  {
    icon: <PiCalendarCheckFill />,
    title: "Showcase Sustainability",
    description: "Communicate your sustainibility vision to attendees through personalized certificates."
  }
];

const Steps = () => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % stepsData.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='new-steps-container'>
      <h1>How it Works?<span className="steps-underline"></span></h1>

      <div className='new-steps-section'>
        {stepsData.map((step, idx) => (
          <React.Fragment key={idx}>
            <div className={`step-item ${activeStep === idx ? 'active-step' : 'inactive-step'}`}>
              <div className="step-card">
                <span className="step-number-badge">{idx + 1}</span>
                <span className="step-icon-circle">{step.icon}</span> 
                <p className='steps-text'>{step.text}</p>
              </div>
            </div>
            {idx < stepsData.length - 1 && (
              <div className="step-arrow-wrapper">
                <FaArrowRight className="step-arrow" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      <div className='key-features'>
        <h1>Key Features<span className="steps-underline"></span></h1>
        <div className='features-grid'>
          {featuresData.map((feature, idx) => (
            <div className="feature-card" key={idx}>
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
      
    </div>
  )
}

export default Steps;
